exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n    width: 100%;\n    border: 0 !important;\n    border-bottom: 1px solid #aaa !important;\n    border-radius: 0 !important;\n    margin-top: 8px;\n}\n\ninput:focus {\n    outline-width: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input/number-input/number-input.component.css
// module id = ./src/app/components/input/number-input/number-input.component.css
// module chunks = main